import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import storage from "@/services/storage";
import { toastMsg } from "@/services/variables";
import { getCookie } from "@/services/generic.methods";
import { globalLogout } from "@/services/generic-logout-method";
import CircularLoader from "@/components/circular-loader";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoggedinUser,
  setProfileToState,
} from "@/store/slices/auth/authSlice";
import { selectRoles, setRolesToState } from "@/store/slices/roles/rolesSlice";
import RoleEngine from "@/services/role-engine";
import { useRouter } from "next/router";
import CRMRoutes from "./crm-routes";
import metaRoutes from "./meta-routes";
import UilCircularLoader from "@/components/circular-loader-uil";

const RouteGuard = (props) => {
  const { children } = props;
  const [isAuth, setAuth] = useState(false);
  const [isAllowed, setIsAllowed] = useState(true);
  const profile = useSelector(getLoggedinUser);
  const roles = useSelector(selectRoles);
  const dispatch = useDispatch();
  const router = useRouter();
  const user = JSON.parse(storage.getItem("Profile"));
  const isAuthenticated = !!getCookie("CRM-Auth");

  const logoutHandler = () => {
    setAuth(false);
    let shouldRedirect = true;
    globalLogout(shouldRedirect);
  };

  const sessionExpireHandler = () => {
    setAuth(false);
    toast.error(toastMsg.errors.inValidAuthToken);
    let shouldRedirect = true;
    globalLogout(shouldRedirect);
  };

  useEffect(() => {
    //set isAuth to false when logout, and show loading for few seconds
    if (!isAuthenticated || (isAuthenticated && !user)) {
      logoutHandler();
    }

    // only call when session expires
    if (!isAuthenticated && user) {
      sessionExpireHandler();
    }

    if (isAuthenticated && user) {
      setAuth(true);
      if (!profile) {
        dispatch(setProfileToState());
      }
      if (!roles || (!Object.keys(roles).length && user?.RoleType)) {
        let tempRoles = RoleEngine(user?.RoleType, user);
        dispatch(setRolesToState(tempRoles));
        // check role if not permit then redirects to permission-denied page
        checkForRoutePermission(tempRoles);
      } else if (!user?.RoleType) {
        router.push("/permission-denied");
      }
    }
  }, [isAuthenticated]);

  const checkForRoutePermission = (permissions) => {
    let path = router.pathname;
    // stop screen on loading untill this function runs
    setIsAllowed(false);
    let currentRoute = metaRoutes.filter((r) => path === r.path);
    let allowed = true;
    if (
      currentRoute.length &&
      currentRoute[0]?.name &&
      currentRoute[0].secondKey
    ) {
      let key = currentRoute[0].name;
      let secondKey = currentRoute[0].secondKey;
      let thirdKey =
        secondKey === "view" || secondKey === "edit" ? null : "view";
      if (
        !(
          permissions[key][secondKey] &&
          (thirdKey === null || permissions[key][secondKey][thirdKey])
        )
      ) {
        allowed = false;
      }
    }
    if (!allowed) {
      router.push("/permission-denied");
      setIsAllowed(false);
    } else {
      setIsAllowed(true);
    }
  };

  return isAuth && isAllowed ? (
    children
  ) : (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "160px" }}
    >
      <UilCircularLoader />
    </div>
  );
};

export default RouteGuard;
